import { useEffect, useState } from 'react';
import io, { Socket } from 'socket.io-client';

interface WebSocketHook {
  isConnected: boolean;
  disconnect: () => void;
  socket: Socket | null;
}

const useWebSocket = (serverUrl: string): WebSocketHook => {
  const [connected, setConnected] = useState<boolean>(false);
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    const newSocket = io(serverUrl);

    newSocket.on('connect', () => {
      setConnected(true);
    });

    newSocket.on('disconnect', () => {
      setConnected(false);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [serverUrl]);

  const disconnect = () => {
    if (socket) {
      socket.disconnect();
    }
  };
  return {
    isConnected: connected,

    disconnect,
    socket,
  };
};

export default useWebSocket;
